import { Injectable } from '@angular/core';
import { injectMutation, injectQuery, QueryKey } from '@tanstack/angular-query-experimental';
import { firstValueFrom, lastValueFrom } from 'rxjs';
import { BaseApiService } from './base.api.service';
import { MeetingEvent } from '../models/meetings.model';


@Injectable({ providedIn: 'root' })
export class MeetingService extends BaseApiService {
  private myMeetings: QueryKey = ['myMeetings'];

  createMeeting = injectMutation(() => ({
    retry: false,
    mutationFn: (args: { siteId: string; intervenantId: string; typeRdvId: string; horaire: string; possiblesIntervenants: string[]; visio: boolean; telephone: string }) =>
      firstValueFrom(
        this.httpClient.post<string>(`${this.baseUrl}/api/meetings/api/meetingevents`, {
          "siteId": args.siteId,
          "intervenantId": args.intervenantId,
          "prestationId": args.typeRdvId,
          "startDateTime": args.horaire,
          "visio": args.visio,
          "telephone": args.telephone,
          "possiblesIntervenants": args.possiblesIntervenants
        }, {
          withCredentials: true,
          responseType: 'text' as 'json',
        })
      ),
    onSettled: () =>
      this.queryClient.invalidateQueries({ queryKey: ['myMeetings'] }),
  }));

  getMeetings(pageNumber: number, pageSize: number) {
    return injectQuery(() => ({
      queryKey: this.myMeetings,
      queryFn: async () => {
        try {
          return await lastValueFrom(
            this.httpClient.get<{ items: MeetingEvent[] }>(`${this.baseUrl}/api/meetings/api/MeetingEvents?PageNumber=${pageNumber}&PageSize=${pageSize}`, {
              withCredentials: true
            })
          );
        } catch (error: any) {
          this.handleError(error);
          throw error;
        }
      },
    }));
  }

  deleteMeeting = injectMutation(() => ({
    mutationFn: async (params: { meetingId: string; skipNotification?: boolean }) => {
      try {
        const url = params.skipNotification
          ? `${this.baseUrl}/api/meetings/api/MeetingEvents/${params.meetingId}?skipNotification=true`
          : `${this.baseUrl}/api/meetings/api/MeetingEvents/${params.meetingId}`;
        return await lastValueFrom(
          this.httpClient.delete(url, {
            withCredentials: true,
          })
        );
      } catch (error: any) {
        this.handleError(error);
        throw error;
      }
    },
    onSuccess: () => {
      this.queryClient.invalidateQueries({ queryKey: this.myMeetings });
    },
  }));
}
